module.exports = __webpack_public_path__ + "static/media/img84_R.a5246b4f.jpg";